import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import logo from "../../../assets/img/logo/logo.png";

function HeaderOne({ className }) {
  const [drawer, setDrawer] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (drawer) {
      document.body.classList.add("mobile-menu-visible");
    } else {
      document.body.classList.remove("mobile-menu-visible");
    }
  }, [drawer]);

  const isActive = (path) => {
    if (path === "/") {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  const menuItems = [
    { name: "Domů", path: "/", active: isActive("/") },
    { name: "O nás", path: "/about", active: isActive("/about") },
    {
      name: "Sortiment",
      path: "/products",
      active: isActive("/products"),
    },
    {
      name: "Služby",
      path: "/services",
      active: isActive("/services"),
    },
    { name: "ISO 9000:2016", path: "/iso", active: isActive("/iso") },
    { name: "Kontakt", path: "/contact", active: isActive("/contact") },
  ];

  const renderMenuItem = (item) => (
    <li className={item.active ? "active" : "" + ""}>
      <a href={item.path}>{item.name}</a>
      {item.children && (
        <ul className="sub-menu">
          {item.children.map((child) => (
            <li key={child.name} className={child.active ? "active" : ""}>
              <a href={child.path}>{child.name}</a>
            </li>
          ))}
        </ul>
      )}
    </li>
  );

  return (
    <header>
      <div
        id="sticky-header"
        className={`menu-area transparent-header ${className || ""}`}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div
                onClick={() => setDrawer(!drawer)}
                className="mobile-nav-toggler"
              >
                <i className="fas fa-bars"></i>
              </div>
              <div className="menu-wrap">
                <nav className="menu-nav">
                  <div className="logo different-logo">
                    <a href="/">
                      <img src={logo} alt="Logo" />
                    </a>
                  </div>

                  <div className="navbar-wrap main-menu d-none d-lg-flex">
                    <ul className="navigation">
                      {menuItems.map(renderMenuItem)}
                    </ul>
                  </div>
                  <div className="header-action d-none d-md-block">
                    <ul className="list-wrap">
                      <li className="header-btn">
                        <a href="/contact" className="btn">
                          KONTAKTUJTE NÁS
                        </a>
                      </li>
                    </ul>
                  </div>
                </nav>
              </div>
              <div className="mobile-menu">
                <nav className="menu-box">
                  <div onClick={() => setDrawer(!drawer)} className="close-btn">
                    <i className="fas fa-times"></i>
                  </div>
                  <div className="nav-logo">
                    <a href="/">
                      <img src={logo} alt="Logo" />
                    </a>
                  </div>
                  <div className="menu-outer">
                    <ul className="navigation">
                      {menuItems.map(renderMenuItem)}
                    </ul>
                  </div>
                </nav>
              </div>
              <div className="menu-backdrop"></div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default HeaderOne;
